import { useLocalStorageState } from "ahooks";
import { useEffect } from "react";
import { safeParse } from "../safeParse";

interface PageVisitRecord {
  count: number;
  date: string;
}

const StoreKey = "page_visit_record";

// 获取当前日期字符串
const getCurrentDate = () => {
  return new Date().toISOString().split("T")[0];
};

const defalutDependencies = [];

/**
 * 记录页面访问数据，记录到localStorage中
 * @param pageKey 页面key值
 */
export const usePageEnterRecord = (
  pageKey: string,
  dependencies = defalutDependencies
) => {
  const [record, setRecord] = useLocalStorageState<
    Record<string, PageVisitRecord>
  >(StoreKey, {
    defaultValue: {},
  });

  useEffect(() => {
    const todayRecord =
      record[pageKey]?.date === getCurrentDate()
        ? record[pageKey]
        : {
            count: 0,
            date: getCurrentDate(),
          };

    todayRecord.count += 1;

    setRecord({
      ...record,
      [pageKey]: todayRecord,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
};

/**
 * 获取页面访问次数
 * @param pageKey
 * @returns 当前页面访问次数
 */
export function getPageEnterRecord(pageKey: string) {
  const record: Record<string, PageVisitRecord> =
    safeParse(localStorage.getItem(StoreKey)) || {};

  const todayRecord =
    record[pageKey]?.date === getCurrentDate()
      ? record[pageKey]
      : {
          count: 0,
          date: getCurrentDate(),
        };

  return todayRecord.count;
}
